
		import { defineComponent, ref, computed, reactive } from "vue";
		import { IUsuarioNuevo } from "@/services/registro/registro_user";
		import useVuelidate from "@vuelidate/core";
		import { required, email, helpers, minValue, sameAs, requiredIf } from "@vuelidate/validators";
		import Registro from "@/services/registro/registro_user.service";
		import spinner from "@/components/master/spinner.vue";
		//CaptchaCanvas
		import CaptchaCanvas from '../captcha/CaptchaCanvas.vue'
		//import vueRecaptcha from 'vue3-recaptcha2';
		import Captcha from '@/services/captcha/captcha';

		export default defineComponent({
				components: {
						spinner, CaptchaCanvas //, vueRecaptcha
				},
				setup() {
						const cargar = ref(false);
						const ServRegistro = new Registro();
						const registroNuevo = ref(true);
						const mostrar_error = ref(false);
						const msg = ref({
								severity: "error",
								content: "",
						});
						// const idSubsector=ref()
						const catsubsector = ref([]);

						const institucion_list = ref<string[]>([]);
						const registro_user = ref<IUsuarioNuevo>();

						//Varibales para la validacion de registro nuevo
						const submit_reg_nuev = ref(false);
						const state_reg_nuev = reactive({
								firstName: "",
								middleName: "",
								lastName: "",
								institutionId: -1,
								institution: "",
								email: "",
								password: "",
								confirm_Password: "",
								idRole: "",
								enabled: false,
								telefono: "",
								idSubsector: -1,
								otroSubsector: "",
						});

						const regexPassword = helpers.regex(
								/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#$@.!%=¡&@#Ññ$¿+*?_/-])(?=\S+$).{8,}.*$/
						);

						const regSequences = helpers.regex(
								/^(?!.*(012|123|234|345|456|567|678|789|ABC|BCD|CDE|DEF|EFG|FGH|GHI|HIJ|IJK|JKL|KLM|LMN|MNO|NOP|OPQ|PQR|QRS|RST|STU|TUV|UVW|VWX|WXY|XYZ|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|0123|1234|2345|3456|4567|5678|6789|ABCD|BCDE|CDEF|DEFG|EFGH|FGHI|GHIJ|HIJK|IJKL|JKLM|KLMN|LMNO|MNOP|NOPQ|OPQR|PQRS|QRST|RSTU|STUV|TUVW|UVWX|VWXY|WXYZ|abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmno|mnop|nopq|opqr|pqrs|qrst|rstu|stuv|tuvw|uvwx|vwxy|wxyz|01234|12345|23456|34567|45678|56789|ABCDE|BCDEF|CDEFG|DEFGH|EFGHI|FGHIJ|GHIJK|HIJKL|IJKLM|JKLMN|KLMNO|LMNOP|MNOPQ|NOPQR|OPQRS|PQRST|QRSTU|RSTUV|STUVW|TUVWX|UVWXY|VWXYZ|abcde|bcdef|cdefg|defgh|efghi|fghij|ghijk|hijkl|ijklm|jklmn|klmno|lmnop|mnopq|nopqr|opqrs|pqrst|qrstu|rstuv|stuvw|tuvwx|uvwxy|vwxyz)).*/
						);

						const regexNotIncludeName = (value: string) => !value.toLowerCase().includes(state_reg_nuev.firstName.toLowerCase());

						const rules_reg_nuev = computed(() => {
								return {
										firstName: {
												required: helpers.withMessage("El nombre es requerido.", required),
										},
										middleName: {
												required: helpers.withMessage(
														"El apellido paterno es requerido.",
														required
												),
										},
										lastName: {
												required: helpers.withMessage(
														"El apellido materno es requerido.",
														required
												),
										},
										institution: {
												required: helpers.withMessage(
														"La institución es requerida.",
														required
												),
										},
										email: {
												required: helpers.withMessage("El correo es requerido.", required),
												email: helpers.withMessage(
														"El correo no cumple con el formato",
														email
												),
										},
										password: {
												required: helpers.withMessage("Introduzca la contraseña", required),
												val_format: helpers.withMessage(
														"La contraseña no cumple con el formato.",
														regexPassword
												),
												val_secuencia: helpers.withMessage(
														"La contraseña no permite secuencias.",
														regSequences
												),
												val_sin_user: helpers.withMessage(
														"La contraseña no debe incluir el nombre del usuario.",
														regexNotIncludeName
												),
										},
										confirm_Password: {
												required: helpers.withMessage(
														"La confirmación es requerida.",
														required
												),
												sameAs: helpers.withMessage(
														"La contraseña no coincide.",
														sameAs(state_reg_nuev.password)
												),
										},

										idSubsector: {
												required: helpers.withMessage(
														"El sector es requerido.",
														minValue(0)
												),
										},
										otroSubsector: {
												required: helpers.withMessage(
														"El sector es requerido.",
														requiredIf(state_reg_nuev.idSubsector == 4)
												),
										},

								};
						});

						const vN$ = useVuelidate(rules_reg_nuev, state_reg_nuev);

						// recaptcha
						//const recaptchaPublicKey = ref(null);
						//const recaptchaSecretKey = (null);
						const captchaValida = ref(false);
						const captchaRequerida = ref(false);
						//servicio
						const servCaptcha = ref(new Captcha)

						return {
								mostrar_error,
								msg,
								cargar,
								registroNuevo,
								ServRegistro,
								catsubsector,
								registro_user,
								state_reg_nuev,
								vN$,
								submit_reg_nuev,
								institucion_list,							
								captchaValida,//recaptchaSecretKey, recaptchaPublicKey,
								captchaRequerida,
								servCaptcha
						};
				},

				methods: {
						submit_nuevo_user() {
								this.vN$.$validate();
								this.submit_reg_nuev = true;

								if (this.vN$.$error) {
										return;
								}
								this.validarCaptcha();								
								if (!this.captchaValida) {
										this.captchaRequerida = true;
										return;
								}
								this.cargar = true;
								this.Crear_usuario_nuevo();
						},

						cancelarRegistro() {
								this.vN$.$reset();
						},

						async Crear_usuario_nuevo() {
								try {
										this.registro_user = {
												firstName: this.state_reg_nuev.firstName,
												middleName: this.state_reg_nuev.middleName,
												lastName: this.state_reg_nuev.lastName,
												institutionId: null,
												institution: this.state_reg_nuev.institution,
												email: this.state_reg_nuev.email,
												password: this.state_reg_nuev.password,
												enabled: true,
												sectorId: this.state_reg_nuev.idSubsector,
												sector: this.state_reg_nuev.idSubsector == 4 ?
														this.state_reg_nuev.otroSubsector : this.catsubsector.filter(
																(e) => e.id_sector == this.state_reg_nuev.idSubsector
														)[0].nombre_sector,
												phoneNumber: this.state_reg_nuev.telefono,
										};
										this.ServRegistro.Crear_Usuario_pub(this.registro_user).then((response) => {
												const respuesta = this.evalRespuestaAPI(response);
												if (respuesta != null) {
														this.registroNuevo = false;
												}
												this.cargar = false

										});
								} catch (error) {
										this.mostrar_error = true;
										this.msg.content = "Error en " + error;
										this.cargar = false;
								}
						},

						validarCaptcha(){
				// Validar CaptchaCanvas
				const userInput = this.$refs.captchaRef?.getUserInput() || '';
				const currentCode = this.$refs.captchaRef?.getCurrentCode() || '';
				const isValid = userInput.trim() === currentCode;
				this.captchaValida = isValid;
				//console.log('Validando CaptchaCanvas:', { userInput, currentCode, isValid });
				if(!isValid) {
						this.$refs.captchaRef?.generate();
						this.captchaRequerida = false;
						this.$toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'El código de validación es incorrecto. Intenta de nuevo.', life: 5000 })
						return;
				}
		},

				VerDifusion() {
				window.location.href = process.env.VUE_APP_URL_DIFUSION;
		},

				evalRespuestaAPI(response) {
				if(response.success) {
				if (response.data.length == 0) {
						this.$toast.add({
								severity: "success",
								summary: "Información",
								detail: response.message,
								life: 3000,
						});
				}
		} else {
				if (response.errors.length > 0) {
						response.errors.forEach((element) => {
								this.$toast.add({
										severity: "warn",
										summary: "Advertencia: " + response.message,
										detail: element.message,
										life: 3000,
								});
						});
				} else {
						this.$toast.add({
								severity: "warn",
								summary: "Advertencia",
								detail: response.message,
								life: 3000,
						});
				}
		}
		return response.data;
				},

		//onCaptchaVerified(response){
		//   const params = {
		//            "secretKey": this.recaptchaSecretKey,
		//            "recaptcha": response
		//        }

		//    this.servCaptcha.obtenerVerificacionCaptcha(params).then((response)=>{
		//        //console.log('verif', response)

		//        this.captchaValida = response.data.success;

		//        if(!this.captchaValida ){
		//            this.mostrar_error = true;
		//            this.msg.content = response.data.errorCodes;
		//        }
		//        else{
		//            this.captchaRequerida = false;
		//        }
		//    })
		//    .catch(error => {
		//        this.mostrar_error = true;
		//        this.msg.content = error;
		//    })

		//},

		//onCaptchaExpired(){
		//    this.$refs.vueRecaptcha.reset();
		//    this.captchaValida = false;
		//},

		//getKeysRecaptcha(){
		//		this.servCaptcha.GetKeysRecaptcha()
		//				.then((response) => {
		//						//console.log(response.data);
		//						this.evalRespuestaAPI(response.data);

		//						if (response.data.success) {
		//								this.recaptchaPublicKey = response.data.data.recaptchaPublicKey
		//								//console.log(this.publicRecaptchaKey)
		//								this.recaptchaSecretKey = response.data.data.recaptchaSecretKey
		//						}
		//				})
		//}
		},

		beforeMount(){
				Promise.all([
						//this.getKeysRecaptcha()
				]);
		},

		mounted() {
				this.ServRegistro.getCatSubsector().then((response) => {
						this.catsubsector = this.evalRespuestaAPI(response);
				});
		},
});
